'use strict';

var _ = require('lodash');
function FlightSummaryGridController($scope, $rootScope, constants, dataService, classIndexMappingService, reservationSystemService, flightAnalysisGridService, scenarioService, reoptimizationService, userPreferencesService, fcrService) {
  $scope.gridId = constants.GRIDS.FLIGHT_SUMMARY;
  $scope.data = [];
  $scope.controlTypes = ['Availability', 'Authorization', 'Ttl Bookings'];
  $scope.controlTypesToMetrics = {
    Bookings: ['Ttl Bookings']
  };
  $scope.controlType = $scope.controlTypes[0];
  $scope.needSelectDefaultRow = true;
  function controlTypeToMetric(controlType) {
    var metric = controlType;
    for (var metricName in $scope.controlTypesToMetrics) {
      if (_.includes($scope.controlTypesToMetrics[metricName], controlType)) {
        metric = metricName;
        break;
      }
    }
    return metric;
  }
  $scope.refreshData = function (silently) {
    return dataService.getData($scope.screenState).then(function (rawData) {
      $scope.data = dataService.transformData(rawData, controlTypeToMetric($scope.controlType));
      $scope.screenState.profileChartPanel.contextData.flightSummaryRows = $scope.data;
      if (!silently) {
        $scope.$broadcast('brush-filter:filterApplied');
      }
    });
  };
  $scope.onSearchCriteriaChange = function () {
    $scope.screenState.filters = {};
    $scope.needSelectDefaultRow = true;
    $scope.refreshData();
  };
  $scope.classColumnsSorter = function (columns) {
    var uniqueLegs = getUnique('leg');
    var uniqueLegsLength = uniqueLegs.length;
    var uniqueDepartureDates = getUnique('flightDepartureDateMoment');
    var fcrTag = uniqueLegsLength === 1 ? fcrService.getFcrTagForMultipleEntitiesWithMarket(uniqueLegs, uniqueDepartureDates) : fcrService.getFcrTagForMultipleEntities(uniqueDepartureDates);
    var classesIndexes = classIndexMappingService.getClassIndexMapping(uniqueLegs, fcrTag);
    return columns.sort(function (a, b) {
      var value1 = classesIndexes[a.title || a];
      var value2 = classesIndexes[b.title || b];
      return value1 - value2;
    });
  };
  function getUnique(attrName) {
    return _.chain($scope.data).map(attrName).uniq().value();
  }
  $scope.onPanel = function (ev, isExpanded) {
    if (isExpanded) {
      $scope.needSelectDefaultRow = true;
      return $scope.refreshData();
    }
  };
  $scope.fmVisibilityChangeHandler = function (newVal) {
    if (newVal) {
      $scope.needSelectDefaultRow = true;
      $scope.refreshData();
    }
  };
  $scope.updateInventoryControls = function (controlType) {
    $scope.needSelectDefaultRow = false;
    $scope.displayRowFilters = _.clone($scope.screenState.profileChartPanel.contextData.visibleRowProperties.displayRowFilters);
    $scope.controlType = controlType;
    $scope.data = dataService.applyControlType($scope.data, controlTypeToMetric($scope.controlType));
    $scope.$broadcast('brush-filter:filterApplied');
  };
  $scope.refreshFlightSummary = function (withoutClearData) {
    $scope.refreshData(true).then(function () {
      if (!withoutClearData) {
        $scope.$broadcast('grid:clearAndLoadData:' + constants.GRIDS.FLIGHT_SUMMARY);
      }
    });
  };
  $scope.refreshAfterReOpt = function () {
    return $scope.refreshFlightSummary();
  };
  function afterSendCallback(sendGridId) {
    $rootScope.$broadcast('clearChangedValue');
    var nextFlightJumpEnabled = userPreferencesService.getUserSettingComponent('nextFlightAfterSend');
    if (!!~[constants.GRIDS.INVENTORY_MANAGEMENT, constants.GRIDS.OVERBOOKING_MANAGEMENT].indexOf(sendGridId)) {
      if (nextFlightJumpEnabled === true) {
        $rootScope.$broadcast('grid:moveToNextKey:' + constants.GRIDS.FLIGHT_SUMMARY);
      } else {
        $scope.refreshFlightSummary();
      }
    }
  }
  $scope.sendGridHandler = function (evt, targetGridId, preparedToSend) {
    reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    reservationSystemService.send(preparedToSend).then(afterSendCallback.bind(null, targetGridId));
  };
  $scope.onSelectedKey = function (evt, gridId) {
    if (gridId !== $scope.gridId) {
      return;
    }
    $scope.refreshFlightSummary(true);
  };
  $scope.reoptPreviewDataHandler = function (newVal, oldValue) {
    if (newVal && oldValue !== true) {
      var flightSummaryGridId = constants.GRIDS.FLIGHT_SUMMARY;
      var flightSummaryGridDetails = $scope.reoptPreviewData.gridDetails[flightSummaryGridId];
      if (!flightSummaryGridDetails) {
        return;
      }
      var flightDetails = _.find($scope.reoptPreviewData.flightDetails, {
        gridId: flightSummaryGridId
      });
      if (!flightDetails) {
        return;
      }
      flightAnalysisGridService.updateReoptPreviewRows(flightSummaryGridId, flightSummaryGridDetails, [{
        flightNumber: flightDetails.selectedRows[0].flightNumber,
        flightDepartureDateMoment: flightDetails.selectedRows[0].flightDepartureDateMoment
      }], scenarioService.getCurrentUserMDPreviewRequestName());
    }
  };
  $scope.profileChartPanelSwapHandler = function ($event, isShown) {
    if (!isShown) {
      var visibleRowProperties = $scope.screenState.profileChartPanel.contextData.visibleRowProperties;
      $scope.$broadcast('grid:clearAndSelect:' + constants.GRIDS.FLIGHT_SUMMARY, visibleRowProperties.displayRowFilters);
    }
  };
  $scope.gridCustomizationChangedHandler = function (event, gridId) {
    if (gridId === constants.GRIDS.FLIGHT_SUMMARY) {
      $scope.needSelectDefaultRow = true;
    }
  };
  $scope.afterUpdateBoundDataHandler = function (event, data, gridId) {
    if (gridId !== constants.GRIDS.FLIGHT_SUMMARY) {
      return;
    }
    if ($scope.needSelectDefaultRow) {
      $scope.needSelectDefaultRow = false;
      $rootScope.$broadcast('grid:applyDefaultSelection:' + gridId);
    } else if (!!$scope.displayRowFilters) {
      $scope.$broadcast('grid:clearAndSelect:' + constants.GRIDS.FLIGHT_SUMMARY, $scope.displayRowFilters);
      $scope.displayRowFilters = false;
    }
  };
}
FlightSummaryGridController.$inject = ['$scope', '$rootScope', 'FlightManagementConstants', 'FlightSummaryDataService', 'ClassIndexMappingService', 'ReservationSystemService', 'FlightAnalysisGridService', 'ScenarioService', 'ReoptimizationService', 'UserPreferencesService', 'FcrService'];
module.exports = FlightSummaryGridController;